module.exports = {
  __depends__: [
    require(206),
    require(174)
  ],
  __init__: [ 'attachSupport'],
  attachSupport: [ 'type', require(134) ]
};
